import { APIConfig } from "@/lib/api";
import { ApiError } from "@/lib/api/api-error";
import { request as __request } from "@/lib/api/request";
import { getCsrfToken } from "@/providers/auth";
import {
  supplierUserSchema,
  supplierUsersSchema,
} from "./types/supplier-users";

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;

export class SupplierUserService {
  static async getSupplierUsers() {
    try {
      const data = await __request(
        APIConfig,
        {
          method: "GET",
          url: "/api/v1/orders/supplier-user/",
          headers: {
            "X-CSRFToken": getCsrfToken() ?? "",
          },
        },
        supplierUsersSchema,
      );
      return data;
    } catch (error) {
      if (error instanceof ApiError) {
        console.error(
          `[getSupplierUsers] API Error: ${error.message} (Status: ${error.status})`,
          error.body,
        );
      } else {
        console.error("[getSupplierUsers] Unexpected error:", error);
      }
      return null;
    }
  }

  static async getSupplierUser(id: number) {
    try {
      const data = await __request(
        APIConfig,
        {
          method: "GET",
          url: "/api/v1/orders/supplier-user/{id}/",
          path: {
            id: id.toString(),
          },
          headers: {
            "X-CSRFToken": getCsrfToken() ?? "",
          },
        },
        supplierUserSchema,
      );
      return data;
    } catch (error) {
      if (error instanceof ApiError) {
        console.error(
          `[getSupplierUser] API Error: ${error.message} (Status: ${error.status})`,
          error.body,
        );
      } else {
        console.error("[getSupplierUser] Unexpected error:", error);
      }
      return null;
    }
  }

  static async getSupplierUserByEmail(email: string) {
    try {
      const supplierUsers = await SupplierUserService.getSupplierUsers();

      if (!supplierUsers) {
        return undefined;
      }

      return supplierUsers.find((user) => user.user.email === email);
    } catch (error) {
      console.error(
        "[getSupplierUserByEmail] Error finding supplier user by email",
        error,
      );
      return undefined;
    }
  }
}
